import { getFirst } from 'utils/array';
import { Survey } from './types';

/**
 * This is here during the php -> react
 * transition period before we truly unify the app <-> api flow
 * across our clients
 */

const ONBOARDING_ID = '1';

export function isOnboardingSurvey(target: Survey | string) {
  const id = typeof target === 'string' ? target : target.id;

  return `${id}` === ONBOARDING_ID;
}

export function isOnboardingActive(surveys: Survey[]) {
  return surveys.length === 1 && isOnboardingSurvey(getFirst(surveys));
}
